import { Fragment, useMemo } from 'react'
import { MissingStatement } from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import { isoToUTCDateTime, DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { Accordion, List, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const useViewMissingStatementsList = ({
  neededStatements,
}: {
  neededStatements?: MissingStatement[]
}) =>
  useMemo(
    () =>
      neededStatements?.map(
        ({ financial_institution_name, name, mask, statements }) => {
          if (!statements || statements.length === 0) {
            return null
          }
          const accountText = `${financial_institution_name} ${name}: ${mask}`
          return (
            <Fragment key={accountText}>
              <Text variant={TypographyStyles.H3} className="mb-2">
                {accountText}
              </Text>
              <List bulleted>
                {statements.map((statement) => (
                  <List.Item key={`${accountText} ${statement}`}>
                    <Text variant={TypographyStyles.BODY_SM}>
                      {isoToUTCDateTime(statement).toFormat(
                        DATE_FORMATS_LUXON.MONTH_YEAR_LONG
                      )}
                    </Text>
                  </List.Item>
                ))}
              </List>
            </Fragment>
          )
        }
      ),
    [neededStatements]
  )

export const ViewMissingStatementsAccordion = ({
  neededStatements,
  title,
}: {
  neededStatements?: MissingStatement[]
  title: string
}) => {
  const formattedStatements = useViewMissingStatementsList({ neededStatements })
  const filteredStatements = (formattedStatements ?? []).filter(Boolean)

  if (filteredStatements.length === 0) {
    return null
  }

  return (
    <Accordion variant="text" type="single" collapsible>
      <Accordion.Item value={title}>
        <Accordion.Trigger>{title}</Accordion.Trigger>
        <Accordion.Content>{filteredStatements}</Accordion.Content>
      </Accordion.Item>
    </Accordion>
  )
}
